import axios from "axios"
import {defineStore} from "pinia"
import {computed, ref} from "vue"

export const useUserStore = defineStore('UserStore', () => {

	const currentEmail = ref('')
	const isEmailAvailable = ref(false)

	const isLoggedIn = computed(() => window.init.isLoggedIn)

	const checkEmail = async (email) => {
		return new Promise((resolve, reject) => {
			currentEmail.value = email
			isEmailAvailable.value = false

			axios.post(`${window.api.baseUrl}/${window.api.checkEmail.url}`, {
				email
			}, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(({ data }) => {
				if(data.status === 'error') {
					reject(data.message)
				}

				isEmailAvailable.value = (data.status === 'available')
				resolve(isEmailAvailable.value)
			})
		})
	}

	const reset = () => {
		isEmailAvailable.value = false
		currentEmail.value = ''
	}

	return {
		currentEmail,
		isEmailAvailable,
		checkEmail,
		isLoggedIn,
		reset,
	}
})